import { styled } from '@withjoy/joykit';
import type { SystemProps } from './GoogleMapEmbed';

export const StyledMapEmbedWrapper = styled.iframe<SystemProps>`
  border: none;
  box-sizing: border-box;
  border-radius: 8px;
  max-width: 100%;
`;
